import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable, of, Subject, throwError } from "rxjs";
import { User } from "../models/user";
import { catchError, map, switchMap } from "rxjs/operators";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { SECAuth } from "../models/login";
import { UrlConstants } from "../models/urlConstants";
import { ClientData } from "../screens/user-profile/client-data";
import { SymbolCustodianHistoryDto } from "../models/custodianSymbolFilter";

export interface UserProfile {
  RelationCode: string;
  ExchangeCode: string;
  UnifiedCode: string;
  SubNameE: string;
  SubNameA: string;
  UserName: string;
  Phone: string;
  Email: string;
  IdNumber: string;
  Address: string;
  AccountManagerNameE: string;
  AccountManagerNameA: string;
  BranchNameA: string;
  BranchNameE: string;
  IsMargin: boolean;
}

@Injectable({
  providedIn: "root",
})
export class AccountService {
  private userSubject: BehaviorSubject<User>;
  public user: Observable<User>;
  public twfa: Observable<any>;
  private showTicker: BehaviorSubject<any>;
  private showQuickButton: BehaviorSubject<any>;
  isFullMarketUser: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    null
  );

  constructor(private router: Router, private http: HttpClient) {
    this.userSubject = new BehaviorSubject<User>(
      JSON.parse(sessionStorage.getItem("user"))
    );
    this.showTicker = new BehaviorSubject<any>(
      JSON.parse(localStorage.getItem("showTicker"))
    );
    this.showQuickButton = new BehaviorSubject<any>(
      JSON.parse(localStorage.getItem("showQuickButton")) || true
    );

    this.user = this.userSubject.asObservable();
  }

  public get userValue(): User {
    return this.userSubject.value;
  }

  public get Ticker(): any {
    return this.showTicker.value;
  }

  setTicker(show: any) {
    this.showTicker.next(show);
  }
  public get quickButton(): any {
    return this.showQuickButton.value;
  }

  setQuickButton(show: any) {
    this.showQuickButton.next(show);
  }



  // login(username, password) {
  //   return this.http
  //     .post<User>(`${UrlConstants.backofficeUrl}/api/Token/GetToken`, {
  //       UserName: username,
  //       Password: password,
  //     })
  //     .pipe(
  //       map((user) => {
  //         // store user details and jwt token in local storage to keep user logged in between page refreshes

  //         let TOKEN = user["Token"].toString();
  //         sessionStorage.setItem("user", TOKEN);
  //         this.userSubject.next(TOKEN);
  //         // this.getAccountList(user);
  //         return user;
  //       })
  //     );
  // }
  checkAuth(username, password) {
    return this.http.post<User>(
      `${UrlConstants.backofficeUrl}/api/Token/CheckAuthentication`,
      {
        UserName: username,
        Password: password,
      }
    );
  }
  checkSecondAuth(req: SECAuth) {
    const usernamePayload = {
      UserName: req.UserName,
      Parameter: req.Parameter,
    };

    if (!req.RefreshToken) {
      return this.http
        .post(`${UrlConstants.backofficeUrl}/api/Token/CheckSecondAuthentication`, usernamePayload)
        .pipe(
          map((user) => {
            let TOKEN = user["Token"];
            sessionStorage.setItem("user", '"' + TOKEN + '"');
            this.userSubject.next(TOKEN);
            return user;
          })
        );
    }

    const refreshPayload = {
      RefreshToken: req.RefreshToken,
      Parameter: req.Parameter,
    };

    return this.http
      .post(`${UrlConstants.backofficeUrl}/api/Token/CheckSecondAuthenticationRefreshToken`, refreshPayload)
      .pipe(
        catchError((error) => {
          if (
            error.status === 401 ||
            error.status === 403 ||
            (error.error && error.error === 'Refresh Token Expired')
          ) {
            return this.http.post<User>(
              `${UrlConstants.backofficeUrl}/api/Token/CheckSecondAuthentication`,
              usernamePayload
            );
          }
          return throwError(() => error);
        }),
        map((user) => {
          let TOKEN = user["Token"];
          sessionStorage.setItem("user", '"' + TOKEN + '"');
          this.userSubject.next(TOKEN);
          return user;
        })
      );
  }
    GetCustodianSymbols(filter) {
    return this.http.post<SymbolCustodianHistoryDto[]>(
      `${UrlConstants.backofficeUrl}/api/client/GetCustodianSymbols`,
      filter
    );
  }


  logout() {
    // remove user from local storage and set current user to null
    sessionStorage.removeItem("user");
    localStorage.removeItem("userProfile");
    sessionStorage.removeItem("userName");
    localStorage.removeItem("accList");

    this.userSubject.next(null);
    window.location.reload();
    this.router.navigateByUrl("/login");
  }

  VerifyEmail(email) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/Token/VerifyEmail?email=` + email,
      null
    );
  }
  forgetPassword(forgetPassObj) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/Token/ForgetPassword`,
      forgetPassObj
    );
  }
  resetPassword(resetPassObj) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/Token/SetNewPassword`,
      resetPassObj
    );
  }

  getAccountList(token) {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Client/GetAccountList`
    );
  }

  create(user) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/Token/CreateOnlineAccount`,
      user
    );
  }

  saveUserProfile(relCode) {
    this.http
      .get(
        `${UrlConstants.backofficeUrl}/api/Client/GetClientProfile?relationCode=${relCode}`
      )
      .subscribe((res) =>
        localStorage.setItem("userProfile", JSON.stringify(res))
      );
  }

  getUserProfile(): UserProfile {
    return JSON.parse(localStorage.getItem("userProfile")) as UserProfile;
  }

  getAll() {
    return this.http.get<User[]>(`${UrlConstants.backofficeUrl}/users`);
  }

  getById(id: string) {
    return this.http.get<User>(`${UrlConstants.backofficeUrl}/users/${id}`);
  }

  getClientInformation(realtionCode: string) {
    return this.http.get<ClientData>(`${UrlConstants.backofficeUrl}/api/Client/GetClientInformation?relationCode=${realtionCode}`)
  }

  setIsFullMarket(value) {
    this.isFullMarketUser.next(value);
  }

  // update(id, params) {
  //   return this.http
  //     .put(`${UrlConstants.backofficeUrl}/users/${id}`, params)
  //     .pipe(
  //       map((x) => {
  //         // update stored user if the logged in user updated their own record
  //         if (id == this.userValue.id) {
  //           // update local storage
  //           const user = { ...this.userValue, ...params };
  //           sessionStorage.setItem("user", JSON.stringify(user));

  //           // publish updated user to subscribers
  //           this.userSubject.next(user);
  //         }
  //         return x;
  //       })
  //     );
  // }
}
